module.exports = __webpack_public_path__ + "3074db4a2b6f4313eb5c910f3e5edff0.jpg";